const attributes = {
  name: 'Name',
  email: 'Email',
  password: 'Passwort',
  password_confirmation: 'Passwort bestätigen',
}

export default attributes
